import React from 'react'
import PropTypes from 'prop-types'

// Pill styles per derived license status; the status values come from the API
// and are the result of refund/cancel actions (never directly editable)
const STATUS_STYLES = {
  Active: 'bg-status-green text-role-admin',
  Cancelled: 'bg-error-light text-error-dark',
  Refunded: 'bg-blue-300 text-info',
  'Refunded + Cancelled': 'bg-error-light text-error-dark',
}

/**
 *
 * LicenseStatusBadge
 *
 */
const LicenseStatusBadge = ({ status }) => (
  <div
    className={`rounded-full px-2.5 py-0.5 ${
      STATUS_STYLES[status] || 'bg-gray-200 text-gray-600'
    }`}
  >
    <span className="whitespace-nowrap text-xs font-bold">{status}</span>
  </div>
)

LicenseStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
}

export default LicenseStatusBadge
